import gql from 'graphql-tag';
import { CONED_UTILITY_ID } from './guards';

export const CREATE_MOVE_REQUEST = gql`
  mutation CreateMoveRequest($input: CreateMoveRequestInput!) {
    createMoveRequest(input: $input) {
      id
    }
  }
`;

export const UPDATE_MOVE_REQUEST = gql`
  mutation UpdateMoveRequest($input: UpdateMoveRequestInput!) {
    updateMoveRequest(input: $input) {
      id
    }
  }
`;

export const DELETE_MOVE_REQUEST = gql`
  mutation DeleteMoveRequest($input: DeleteMoveRequestInput!) {
    deleteMoveRequest(input: $input) {
      message
    }
  }
`;

export const deleteMoveRequestMock = {
  deleteMoveRequest: {
    message: 'Move request deleted successfully',
  },
};

export const updateMoveRequestMock = {
  updateMoveRequest: {
    id: 7,
  },
};

export const createMoveRequestMock = {
  createMoveRequest: {
    id: 7,
  },
};

export const GET_ACCOUNT_INFO_QUERY = gql`
  query getMovingAccountInfo($id: Int!) {
    account(id: $id) {
      id
      utilityCredentials {
        id
        overrideEmail
      }
      customPlans {
        id
        status
        paymentMethodId
        planTemplateId
        displayName
        name
        utilityAccounts {
          id
        }
      }
      utilityAccounts {
        id
        accountId
        accountNumber
        displayServiceAddress
        connected
        customerClass
        pendingMoveRequest {
          id
        }
        utility {
          id
          displayName
          evergreenOnly
          vnmEligible
        }
        utilityCredential {
          id
          verificationStatus
          username
        }
        moveRequest {
          id
          status
        }
      }
    }
  }
`;

export const getAccountInfoMock = {
  account: {
    id: 2,
    utilityCredentials: [
      {
        id: 1,
        overrideEmail: 'sudo@opensesame.com',
      },
    ],
    customPlans: [
      {
        id: 1,
        displayName: 'nickname',
        name: 'nickname',
        paymentMethodId: null,
        planTemplateId: 1,
        utilityAccounts: [{ id: 1 }],
        status: 'active',
      },
      {
        id: 3,
        displayName: 'coned',
        name: 'coned',
        paymentMethodId: null,
        planTemplateId: 1,
        utilityAccounts: [{ id: 3 }],
        status: 'active',
      },
    ],
    utilityAccounts: [
      {
        id: 1,
        accountId: 1,
        accountNumber: 1234,
        displayServiceAddress: '1234 Street',
        connected: true,
        customerClass: 'RESIDENTIAL',
        pendingMoveRequest: null,
        utility: {
          id: 1,
          displayName: 'Pepco',
          evergreenOnly: false,
          vnmEligible: true,
        },
        utilityCredential: {
          id: 1,
          verificationStatus: 'correct',
          username: 'sudo@opensesame.com',
        },
        moveRequest: [],
      },
      {
        id: 3,
        accountId: 1,
        accountNumber: 1235,
        displayServiceAddress: '1234 Street',
        connected: true,
        customerClass: 'RESIDENTIAL',
        pendingMoveRequest: null,
        utility: {
          id: CONED_UTILITY_ID,
          displayName: 'Pepco',
          evergreenOnly: false,
          vnmEligible: true,
        },
        utilityCredential: {
          id: 1,
          verificationStatus: 'correct',
          username: 'sudo@opensesame.com',
        },
        moveRequest: [],
      },
      {
        id: 2,
        accountId: 2,
        accountNumber: 5678,
        displayServiceAddress: '12345678 Rd',
        connected: false,
        customerClass: 'RESIDENTIAL',
        pendingMoveRequest: null,
        utility: {
          id: 1,
          displayName: 'Pepco',
          evergreenOnly: false,
          vnmEligible: true,
        },
        utilityCredential: {
          id: 1,
          verificationStatus: 'incorrect',
          username: 'fake',
        },
        moveRequest: [{ id: 1, status: 'pending' }],
      },
    ],
  },
};

export const GET_PLAN_TEMPLATE_INFO_QUERY = gql`
  query GetPlanTemplateInfo($utilityId: Int, $visibility: [String!]) {
    planTemplates(utilityId: $utilityId, visibility: $visibility) {
      id
      requiresPaymentMethod
      products {
        id
        defaultAmountCents
        productType
      }
    }
  }
`;

export const FETCH_BILLING_EXPERIENCE_OPTIONS = gql`
  query FetchBillingExperienceOptions(
    $utilityId: Int!
    $enrollmentDataSourceName: EnrollmentOptionName!
    $communitySolarProjectGroupId: Int
  ) {
    billingExperienceOptions(
      utilityId: $utilityId
      enrollmentDataSourceName: $enrollmentDataSourceName
      communitySolarProjectGroupId: $communitySolarProjectGroupId
    ) {
      name
    }
  }
`;

export const fetchBillingExperienceOptionsMock = {
  billingExperienceOptions: [
    {
      name: 'ucb',
    },
    {
      name: 'acb',
    },
  ],
};

export const ucbFetchBillingExperienceOptionsMock = {
  billingExperienceOptions: [
    {
      name: 'ucb',
    },
  ],
};

export const getPlanTemplateInfoMock = {
  planTemplates: [
    {
      id: 1,
      requiresPaymentMethod: false,
      products: [
        {
          id: 1,
          defaultAmountCents: 0,
          productType: 'Wind',
        },
        {
          id: 2,
          defaultAmountCents: 500,
          productType: 'Membership',
        },
      ],
    },
  ],
};

export const getPlanTemplateInfoPaymentRequiredMock = {
  planTemplates: [
    {
      id: 1,
      requiresPaymentMethod: true,
      products: [
        {
          id: 1,
          defaultAmountCents: 0,
          productType: 'Wind',
        },
        {
          id: 2,
          defaultAmountCents: 500,
          productType: 'Membership',
        },
      ],
    },
  ],
};

// TODO stop creating dummy utility accounts in the movers flow when we support multiple utility accounts on a plan
export const CREATE_PLAN = gql`
  mutation CreatePlan($input: CreatePlanWithUtilityAccountInput!) {
    createPlanWithUtilityAccount(input: $input) {
      id
      utilityAccountId
    }
  }
`;

export const createPlanMock = {
  createPlanWithUtilityAccount: { id: 1, utilityAccountId: 1 },
};

export const CREATE_SETUP_INTENT = gql`
  mutation CreateSetupIntent($accountId: Int!) {
    createSetupIntent(
      accountId: $accountId
      achMicrodepositVerification: false
    ) {
      stripeClientSecret
    }
  }
`;

export const createSetupIntentMock = {
  createSetupIntent: {
    stripeClientSecret: 'my_secret',
  },
};

export const GET_MOVERS_PAYMENT_METHODS = gql`
  query GetMoversPaymentMethods($accountId: Int!) {
    account(id: $accountId) {
      id
      paymentMethods {
        id
      }
    }
  }
`;

export const FetchExistingPaymentMethodIdsMock = {
  account: {
    id: 2,
    paymentMethods: [],
  },
};

export const GetMoversPaymentMethodsMock = {
  account: {
    id: 2,
    paymentMethods: [
      {
        id: 1,
      },
    ],
  },
};
